import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from "@angular/core";
import { WSREActionHistoryVM } from "../../../modules/wsre/models/wsre.model";
import { ScreenCode } from "../../enums/allEnums";
import { WsreService } from "../../../modules/wsre/wsre.service";
import { LoadingService } from "../../services/loading.service";
import { TranslateService } from "../../../translate";
import { PageEvent } from "@angular/material/paginator";
import { GETViewPhotoComponent } from "../../../modules/GET_NEW_UI/shared/view-photo/view-photo.component";
import { PhotoModelComingFrom } from "../../../modules/GET_NEW_UI/inspections/inspection.model";
import { MatDialog } from "@angular/material/dialog";

@Component({
  selector: "app-audit-trail",
  templateUrl: "./audit-trail.component.html",
  styleUrls: ["./audit-trail.component.scss"],
})
export class AuditTrailComponent implements OnInit, OnChanges {
  @Input() equipmentId: number;
  @Input() systemIdRight!: string;
  @Input() systemIdLeft!: string;
  @Input() screenId!: number;
  @Input() isInventory: boolean = false;
  @Input() moduleId!: number;
  @Input() itemsPerPage: number = 100;
  @Input() refreshData: number = 0;
  @Input() showFilters: boolean = true;
  auditTrailHistory: WSREActionHistoryVM[] = [];
  loadSize: number = 100;
  loadingPage: number = 1;
  auditTrailTotalRecords: number = 0;
  systemUpdates: boolean = true;
  componentRepairs: boolean = true;
  componentMeasurementUpdates: boolean = false;

  constructor(
    private _wsreService: WsreService,
    private _loading: LoadingService,
    private _dialog: MatDialog,
  ) {}

  ngOnInit() {
    //if (this.moduleId == 3) this.loadSize = this.itemsPerPage;
    if (this.equipmentId > 0 && this.screenId == 14 && this.moduleId == 2) {
      this.loadHistory();
    }
    else if (this.systemIdLeft || this.systemIdRight) {
      this.loadActionHistory(this.loadingPage, this.loadSize);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["refreshData"]) {
      this.loadActionHistory(this.loadingPage, this.loadSize);
    }
  }


  loadHistory() {
    const ids = [this.systemIdLeft, this.systemIdRight].filter(
      (id) => id != null,
    );
    const systemIds: string = ids.length ? ids.join(",") : "";
    this._loading.startLoading();
    this._wsreService.getAuditLogHistory(
      this.equipmentId,
        this.screenId,
        this.moduleId,
        this.loadingPage,
        this.loadSize
      )
      .subscribe({
        next: (res) => {
          console.log(res.Data);
          this.auditTrailHistory = res.Data;
          this.auditTrailTotalRecords = res.TotalRecords;
        },
        error: (err) => {
          console.error("Failed to load history", err);
          this._loading.finishedLoading();
        },
        complete: () => {
          this._loading.finishedLoading();
        },
      });
  }

  loadActionHistory(loadingPage: number, pageSize: number) {
    const ids = [this.systemIdLeft, this.systemIdRight].filter(
      (id) => id != null,
    );
    const systemIds: string = ids.length ? ids.join(",") : "";
    this._loading.startLoading();
    this._wsreService
      .getActionHistory(
        systemIds,
        this.screenId,
        this.moduleId,
        loadingPage,
        pageSize,
        this.systemUpdates,
        this.componentRepairs,
        this.componentMeasurementUpdates
      )
      .subscribe({
        next: (res) => {
          console.log(res.Data);
          this.auditTrailHistory = res.Data;
          this.auditTrailTotalRecords = res.TotalRecords;
        },
        error: (err) => {
          console.error("Failed to load history", err);
          this._loading.finishedLoading();
        },
        complete: () => {
          this._loading.finishedLoading();
        },
      });
  }
  pageChanged(event: PageEvent) {
    console.log(event);
    this.loadActionHistory(event.pageIndex + 1, event.pageSize);
  }

  isImage(value: string | null | undefined): boolean {
    if (!value) return false;
    const lower = value.toLowerCase();
    return (
      lower.endsWith(".png") ||
      lower.endsWith(".jpg") ||
      lower.endsWith(".jpeg") ||
      lower.endsWith(".ico")
    );
  }

  viewInspectionImage(img: string, id: number) {
    const passingData = {
      comingFrom: PhotoModelComingFrom.AuditTrail,
      image: img.replace("Thumbnail_S", ""),
      Id: id,
      ImageUrl: true,
      IsViewMode: true,
    };
    const viewInspectionPhoto = this._dialog.open(GETViewPhotoComponent, {
      width: "1032px",
      data: passingData,
    });
    viewInspectionPhoto.afterClosed().subscribe((changes) => {});
  }
}
